import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://kpjyipdfykgbsoemuxib.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtwanlpcGRmeWtnYnNvZW11eGliIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTg1MDQ1NDcsImV4cCI6MTk3NDA4MDU0N30.3IcIvuoViMSRrxA5g1plxiIgGqY0l2CrcLNRbQ_VzcY";
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
